const makeSelectFilterOption = (searchValue, inputValue) => searchValue.toLowerCase().indexOf(inputValue.toLowerCase()) >= 0;


export default makeSelectFilterOption;
